<template>
    <div>
        <template>
            <base-loading-indicator-box v-if="zapServicesLoading">
            </base-loading-indicator-box>
            <zap-services-status-list :services="zapServices" v-else></zap-services-status-list>
        </template>

        <base-heading-secondary class="mt-5" text="Availability for the last days"></base-heading-secondary>
        <base-loading-indicator-box v-if="incidentHistoryLoading" class="mt-6">
        </base-loading-indicator-box>
        <incident-history v-else :history="incidentHistory" :dateHistoryEnabled="false" class="mt-6"></incident-history>

        <div class="grid grid-cols-6 gap-6 mt-12">
            <div class="col-span-6 md:col-span-3 xl:col-span-4">
                <base-loading-indicator-box v-if="interruptionsLoading" class="mt-6">
                </base-loading-indicator-box>
                <div v-else>
                    <base-heading-secondary text="Interruptions"></base-heading-secondary>

                    <base-list-with-heading class="mt-6" v-if="Object.keys(interruptions).length > 0">
                        <template v-slot:header>
                            <span class="text-base text-gray-800">Interruptions</span>
                        </template>

                        <incident-list-with-heading-entry v-for="incident in interruptions" :interruption="incident" :key="incident.id">
                        </incident-list-with-heading-entry>
                    </base-list-with-heading>

                    <base-card class="text-gray-600 text-sm mt-6" v-if="Object.keys(interruptions).length === 0">
                        <p>Currently there are no interruptions known for your services. Great! 🔥</p>
                        <p>If you still notice any issues with your services, don't hesitate to <a href="https://zap-hosting.com/de/customer/support/">write us a support ticket</a> so we can take a look at the problem and fix it with you!</p>
                    </base-card>
                </div>
            </div>

            <div class="col-span-6 md:col-span-3 xl:col-span-2">
                <base-heading-secondary text="Your Service Hosts"></base-heading-secondary>

                <base-loading-indicator-box class="mt-6" v-if="serviceHostsLoading">
                </base-loading-indicator-box>
                <base-card class="mt-6 text-gray-600 text-sm" v-else>
                    <ul>
                        <li v-for="host in serviceHosts" :key="host.id"><a :href="detailHostRoute(host)" v-html="host.name"></a></li>
                    </ul>
                </base-card>
            </div>
            <rate-limit-exceeded-modal :open="rateLimitExceeded"></rate-limit-exceeded-modal>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        lookupId: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            incidentHistoryLoading: true,
            incidentHistory: Array,
            serviceHostsLoading: true,
            serviceHosts: Array,
            interruptionsLoading: true,
            interruptions: Object,
            rateLimitExceeded: false,
            zapServicesLoading: true,
            zapServices: Array,
        }
    },
    methods: {
        handleRateLimit() {
            this.rateLimitExceeded = true;
        },

        fetchAffectedHosts() {
            this.serviceHostsLoading = true;

            axios.get(route('api.lookup.hosts', {
                lookup: this.lookupId
            })).then(function (response) {
                this.serviceHosts = response.data.hosts;

                this.serviceHostsLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        fetchInterruptions() {
            this.interruptionsLoading = true;

            axios.get(route('api.lookup.interruptions', {
                lookup: this.lookupId
            })).then(function (response) {
                this.interruptions = response.data.interruptions;

                this.interruptionsLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        fetchHistory() {
            this.incidentHistoryLoading = true;

            axios.get(route('api.lookup.history', { lookup: this.lookupId })).then(function (response) {
                this.incidentHistory = response.data.history;

                this.incidentHistoryLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        fetchZapServices() {
            this.zapServicesLoading = true;

            axios.get(route('api.zapServices')).then(function (response) {
                this.zapServices = response.data.services;

                this.zapServicesLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        refresh() {
            this.rateLimitExceeded = false;

            this.fetchAffectedHosts();
            this.fetchInterruptions();
            this.fetchHistory();
            this.fetchZapServices()
        },
        detailHostRoute(host) {
            return route('host', {
                hostID: host.id
            });
        },
    },
    mounted() {
        this.$eventHub.$on('refresh', this.refresh);

        setTimeout(function () {
            this.refresh();
        }.bind(this), 1000);

        window.addEventListener('hashchange', function() {
            this.fetchInterruptions();
        }.bind(this), false);
    },
}
</script>
